import React, { useContext, useState } from "react";
import "./PeasantTheme.css";

import {
  MenuOutlined,
  QrcodeOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { downArrow, upArrow } from "../Common/SvgIcon";
import { swipeUparrow, swipeDown1 } from "../Common/SvgIcon";
import {
  defaultBackgroundImage,
  defaultProfileImage,
} from "../Common/DefaultImage";
import { FloatButton } from "antd";
import { FaExchangeAlt, FaLocationArrow } from "react-icons/fa";
// import QRModal from "../Common/QRModal";
import HighlightImage from "../Common/highlightImagesCards/HighlightImage";
import SlideSocialMedia from "../Common/socialMedia/SlideSocialMedia";
import { HighlightImageValid, SocialMediaValid } from "../Common/DivValidation";
import { Link } from "react-router-dom";
import ProfileCardUltra from "../Common/profileCards/ProfileCardUltra";
import ProfileCardGlassy from "../Common/profileCards/ProfileCardGlassy";
import WebsiteUltra from "../Common/websiteCards/WebsiteUltra";
import ReviewCardUltra from "../Common/reviewCards/ReviewCardUltra";
import DownloadCardUltra from "../Common/fileDownloadsCards/DownloadCardUltra";
import ContactCardGlassy from "../Common/contactCards/ContactCardGlassy";
import SlideSocialMedias from "../Common/socialMedia/SlideSocialMedias";
import WebsiteBasic from "../Common/websiteCards/WebsiteBasic";
import VerticalSlideSMVex from "../Common/socialMedia/VerticalSlideSMVex";
import ReviewCardBasic from "../Common/reviewCards/ReviewCardBasic";

import DownloadBasic from "../Common/fileDownloadsCards/DownloadBasic";
import ProfileCardPrism from "../Common/profileCards/ProfileCardPrism";
import ContactCardPrism from "../Common/contactCards/ContactCardPrism";
import HorsizontalscrollGlassy from "../Common/socialMedia/HorsizontalscrollGlassy";
import ContactCardpeasant from "../Common/contactCards/ContactCardpeasant";
import ExchangeContact from "../Common/exchangeContactModal/ExchangeContact";
import { CardContext } from "../../store/CardContext";
import Footer from "../Common/footer/Footer";
import QRModal from "../Common/qrModals/QRModal";
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../helpers/tapCountMutation";

// import SlideSocialMedias from '../Common/socialMedia/SlideSocialMedias';
function PeasantTheme({ preview, card }) {
  const [showGallery, setShowGallery] = useState(false);

  const toggleGallery = () => {
    setShowGallery(!showGallery);
  };
  const [showDownloads, setshowDownloads] = useState(false);

  const toggleDownloads = () => {
    setshowDownloads(!showDownloads);
  };
  const shareMail = (e) => {
    window.location = `mailto:${personalDetails?.email}`;
    e.preventDefault();
  };
  const shareMail2 = (e) => {
    window.location = `mailto:${personalDetails?.secondaryEmail}`;
    e.preventDefault();
  };
  const [cardData] = useContext(CardContext)

  const {
    profileImage,
    backgroundImage,
    personalDetails,
    checkProfile,
    contactDetails,
    socialMedias,
    website,
    review,
    fileName,
    files,
    SMediaPostion,
    companyLogo,
    checkLogo,
    vCard,
    checkExchangeContact,
    exchangeContact,
    footerText,
    emailList

  } = cardData

  // const files = {
  //   file1: file1,
  //   file2: file2,
  //   file3: file3,
  //   file4: file4,
  // };


  const Highlightcolor = card?.colorCode ? card?.colorCode : "";

  const BgColor = card?.bgColor ? card?.bgColor : "";
  const Textcolor = card?.textColor ? card?.textColor : "#FFFFFF";
  const Iconcolor = card?.iconBgColor ? card?.iconBgColor : "#FFFFFF";
  const BtIColor = card?.btIconColor ? card?.btIconColor : "#FFFFFF";
  // const files = {
  //   file1: file1,
  //   file2: file2,
  //   file3: file3,
  //   file4: file4,
  // };
  const [isExpanded, setIsExpanded] = useState(false);
  const [qrModal, setQrModal] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          text: "Please check it out.",
          url: window.location.href,
          title: "ZEEQR",
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    }
  };

  const handleClose = (e) => {
    setQrModal(false);
  };

  const HighlightImageCheck = HighlightImageValid();
  const SocialMediaImageCheck = SocialMediaValid();

  // const pfImage =
  //   profileImage[0]?.thumbUrl && profileImage[0]?.status !== "removed"
  //     ? profileImage[0]?.originFileObj?.type
  //       ? URL.createObjectURL(profileImage[0]?.originFileObj)
  //       : profileImage[0].thumbUrl
  //     : defaultProfileImage;

  const pfImage = profileImage ? profileImage : defaultProfileImage

  const imageStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: `url(${pfImage})`,
    backgroundRepeat: "no-repeat",
    // backgroundAttachment: "sticky"
  };

  const exchangeButton = (

    <span
      className="flex items-center justify-center "

    >
      <FaExchangeAlt size={14} color={BtIColor} />
    </span >
  )

  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button) => {
    // console.log("iiii");

    updateTapCount(queryClient, button);
  };

  return (
    <>
      <div className="digitalcontainer6 ">
        <div className="digitalcontainer_center6  ">
          <div
            className="digitalcontainer_banner6 relative h-screen overflow-auto scrollbar-hide "
            style={{ backgroundColor: `${BgColor ? BgColor : "#530404"}` }}
          >
            <div
              className="w-full h-[350px] overflow-hidden  "
              style={{
                borderTopRightRadius: "5px",
                borderBottomRightRadius: "357px",
                position: "relative",
                backgroundColor: `${Highlightcolor ? Highlightcolor : "#650A0A"
                  }`,
              }}
            >
              <div className="flex justify-center items-center mt-[50px] ml-5">
                <div className="w-[139px] h-[139px]  border-[4px] border-[#D9D9D9] overflow-hidden rounded-full">

                  <img
                    className='sticky w-full h-full object-cover'
                    src={profileImage ? profileImage : defaultProfileImage}
                    alt=""
                    style={{ borderRadius: '30px' }}
                  />
                  {/* {profileImage[0]?.thumbUrl &&
                  profileImage[0]?.status !== "removed" ? (
                    <img
                      className="sticky top-0 w-full h-full object-cover"
                      src={
                        profileImage[0]?.originFileObj?.type
                          ? URL.createObjectURL(profileImage[0]?.originFileObj)
                          : profileImage[0].thumbUrl
                      }
                      alt=""
                      style={{
                        borderTopRightRadius: "157px",
                        borderBottomRightRadius: "157px",
                      }}
                    />
                  ) : (
                    <img
                      className="sticky w-full h-full object-cover"
                      src={defaultProfileImage}
                      alt=""
                      style={{ borderRadius: "30px" }}
                    />
                  )} */}
                </div>
                <div className="info text-[21px]">
                  <ProfileCardPrism
                    preview={preview}
                    textStyle={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  />
                </div>
              </div>
{personalDetails?.email || personalDetails.secondaryEmail ?
              <p className="text-[14px] font-medium text-center mt-5 overflow-auto max-w-[200px] scrollbar-hide" style={{ color: Textcolor }}>
                <Link onClick={preview ? shareMail : ""}>
                  {personalDetails?.email
                    ? personalDetails.email
                    : "john@example.com"}
                </Link>

                <div className="mt-2">
                  <Link onClick={preview ? shareMail2 : ""}>
                    {personalDetails?.secondaryEmail
                      ? personalDetails.secondaryEmail
                      : ""}
                  </Link>
                </div>
              </p>
              : ""
              }
                  <p className="text-[14px] font-medium text-center mt-5 overflow-auto max-w-[200px] scrollbar-hide" style={{ color: Textcolor }}>
          
                <div className="mt-2">
                  <Link onClick={preview ? shareMail2 : ""}>
                    {personalDetails?.secondaryEmail
                      ? personalDetails.secondaryEmail
                      : emailList[0].email}
                  </Link>
                </div>
              </p>

              {socialMedias && socialMedias.length !== 0 && (
                <div
                  className=" w-[170px] p-2"
                  style={{
                    borderTopRightRadius: "21px",
                    borderBottomRightRadius: "21px",
                    position: "relative",
                    backgroundColor: `${BgColor ? BgColor : "#530404"}`,
                  }}
                >
                  <HorsizontalscrollGlassy
                    preview={preview}
                    color={BtIColor}
                    limit={5}
                    arrow={"40px"}
                    widthsize={""}
                  />
                </div>
              )}
            </div>

            <div className="glassythemedetails">
              <div className="flex justify-end">
                <div className="fixed top-5 m-5">
                  <div>
                    <Link
                      className="flex gap-2 h-[40px] "
                      to={`${preview ? contactDetails?.locationUrl : ""}`}
                      target={`${preview ? "_blank" : ""}`}
                    >
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.11425 10.0068H7.1611C6.6431 10.0068 6.14631 10.2126 5.78002 10.5789C5.41374 10.9451 5.20796 11.4419 5.20796 11.9599V21.335C5.20796 21.853 5.41374 22.3498 5.78002 22.7161C6.14631 23.0824 6.6431 23.2882 7.1611 23.2882H18.88C19.398 23.2882 19.8948 23.0824 20.2611 22.7161C20.6274 22.3498 20.8331 21.853 20.8331 21.335V11.9599C20.8331 11.4419 20.6274 10.9451 20.2611 10.5789C19.8948 10.2126 19.398 10.0068 18.88 10.0068H16.9268M9.11425 6.88176L13.0205 2.97546M13.0205 2.97546L16.9268 6.88176M13.0205 2.97546V16.3057"
                          stroke={BtIColor}
                          stroke-width="1.56252"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className="flex gap-2 justify-end  "
                style={{ position: "absolute", top: 200, right: 5 }}
              >



                <Link
                  onClick={() => handleTap('saveContact')}
                  to={`${preview ? vCard : ''}`}
                >
                  <div className="pb-3">
                    <svg width="40" height="40" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="22.8046" cy="22.8046" r="20.8046" fill="white" />
                      <circle cx="22.8046" cy="22.8046" r="21.8046" stroke="white" stroke-opacity="0.4" stroke-width="2" />
                      <g clip-path="url(#clip0_365_121)">
                        <path d="M26.8047 24.8047C28.1308 24.8047 29.4025 25.3315 30.3402 26.2692C31.2779 27.2068 31.8047 28.4786 31.8047 29.8047V30.8047C31.8047 31.3351 31.594 31.8438 31.2189 32.2189C30.8438 32.594 30.3351 32.8047 29.8047 32.8047H15.8047C15.2743 32.8047 14.7655 32.594 14.3905 32.2189C14.0154 31.8438 13.8047 31.3351 13.8047 30.8047V29.8047C13.8047 28.4786 14.3315 27.2068 15.2692 26.2692C16.2068 25.3315 17.4786 24.8047 18.8047 24.8047H26.8047ZM30.8047 18.8047C31.0699 18.8047 31.3243 18.91 31.5118 19.0976C31.6993 19.2851 31.8047 19.5395 31.8047 19.8047V20.8047H32.8047C33.0699 20.8047 33.3243 20.91 33.5118 21.0976C33.6993 21.2851 33.8047 21.5395 33.8047 21.8047C33.8047 22.0699 33.6993 22.3243 33.5118 22.5118C33.3243 22.6993 33.0699 22.8047 32.8047 22.8047H31.8047V23.8047C31.8047 24.0699 31.6993 24.3243 31.5118 24.5118C31.3243 24.6993 31.0699 24.8047 30.8047 24.8047C30.5395 24.8047 30.2851 24.6993 30.0976 24.5118C29.91 24.3243 29.8047 24.0699 29.8047 23.8047V22.8047H28.8047C28.5395 22.8047 28.2851 22.6993 28.0976 22.5118C27.91 22.3243 27.8047 22.0699 27.8047 21.8047C27.8047 21.5395 27.91 21.2851 28.0976 21.0976C28.2851 20.91 28.5395 20.8047 28.8047 20.8047H29.8047V19.8047C29.8047 19.5395 29.91 19.2851 30.0976 19.0976C30.2851 18.91 30.5395 18.8047 30.8047 18.8047ZM22.8047 12.8047C24.1308 12.8047 25.4025 13.3315 26.3402 14.2692C27.2779 15.2068 27.8047 16.4786 27.8047 17.8047C27.8047 19.1308 27.2779 20.4025 26.3402 21.3402C25.4025 22.2779 24.1308 22.8047 22.8047 22.8047C21.4786 22.8047 20.2068 22.2779 19.2692 21.3402C18.3315 20.4025 17.8047 19.1308 17.8047 17.8047C17.8047 16.4786 18.3315 15.2068 19.2692 14.2692C20.2068 13.3315 21.4786 12.8047 22.8047 12.8047Z" fill={BtIColor} />
                      </g>
                      <defs>
                        <clipPath id="clip0_365_121">
                          <rect width="24" height="24" fill="white" transform="translate(10.8047 10.8047)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </Link>

                {/* <div>
                  <Link
                    to={`${preview ? contactDetails?.locationUrl : ""}`}
                    target={`${preview ? "_blank" : ""}`}
                  >
                    <svg
                      width="44"
                      height="44"
                      viewBox="0 0 52 52"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_365_195)">
                        <circle
                          cx="26"
                          cy="22"
                          r="20"
                          fill="white"
                          shape-rendering="crispEdges"
                        />
                        <circle
                          cx="26"
                          cy="22"
                          r="21"
                          stroke="white"
                          stroke-opacity="0.4"
                          stroke-width="2"
                          shape-rendering="crispEdges"
                        />
                      </g>
                      <rect
                        width="24"
                        height="24"
                        transform="translate(14 10)"
                        fill="white"
                      />
                      <path
                        d="M29.75 25.75H33.5V29.5H29.75V25.75ZM26.75 22.75H29.75V25.75H26.75V22.75ZM33.5 29.5H36.5V32.5H33.5V29.5ZM34.25 22.75H36.5V25H34.25V22.75ZM26.75 30.25H29V32.5H26.75V30.25ZM29.75 14.5H33.5V18.25H29.75V14.5Z"
                        fill="#530404"
                      />
                      <path
                        d="M36.5 21.25H26.75V11.5H36.5V21.25ZM28.8125 19.1875H34.4375V13.5625H28.8125V19.1875ZM18.5 14.5H22.25V18.25H18.5V14.5Z"
                        fill="#530404"
                      />
                      <path
                        d="M25.25 21.25H15.5V11.5H25.25V21.25ZM17.5625 19.1875H23.1875V13.5625H17.5625V19.1875ZM18.5 25.75H22.25V29.5H18.5V25.75Z"
                        fill="#530404"
                      />
                      <path
                        d="M25.25 32.5H15.5V22.75H25.25V32.5ZM17.5625 30.4375H23.1875V24.8125H17.5625V30.4375Z"
                        fill="#530404"
                      />
                      <defs>
                        <filter
                          id="filter0_d_365_195"
                          x="0"
                          y="0"
                          width="52"
                          height="52"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_365_195"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_365_195"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </Link>
                </div> */}
              </div>
              <div className="ml-[20px] mt-[40px]">
                <div className="">
                  <div className="flex justify-start items-center gap-2 w-full">
                    <div className="w-[50%]">
                      <p className="text-[19px] font-semibold flex items-center text-start" style={{ color: Textcolor }}>
                        About me
                      </p>
                    </div>
                    <div className="flex items-center pb-1 w-full">
                      <p className="w-[13px] flex items-center rounded-full h-[13px] bg-white"></p>
                      <p className="w-full h-[2px] bg-white"></p>
                    </div>
                  </div>

                  {personalDetails?.about && (
                    <div className="text-start">
                      <p className="text-[14px] font-medium whitespace-pre-line" style={{ color: Textcolor }}>
                        {personalDetails?.about}
                      </p>
                    </div>
                  )}
                  <div className="">
                    <ContactCardpeasant preview={preview} />
                  </div>
                  {website[0]?.websiteName ? (
                    <>
                      <div className="">
                        <div className="flex mt-[40px] justify-start items-center gap-2 w-full">
                          <div className="w-[40%]">
                            <p className="text-[19px] font-semibold flex items-center text-start" style={{ color: Textcolor }}>
                              Website
                            </p>
                          </div>
                          <div className="flex items-center pb-1 w-full">
                            <p className="w-[13px] flex items-center rounded-full h-[13px] bg-white"></p>
                            <p className="w-full h-[2px] bg-white"></p>
                          </div>
                        </div>
                        <div className="flex justify-start">
                          <WebsiteBasic preview={preview} color={BtIColor} Iconcolor={Iconcolor} textColor={Textcolor} />
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {review[0]?.reviewName ? (
                    <>
                      <div className="flex mt-[40px] justify-start items-center gap-2 w-full">
                        <div className="w-[30%]">
                          <p className="text-[19px] font-semibold flex items-center text-start" style={{ color: Textcolor }}>
                            Review
                          </p>
                        </div>
                        <div className="flex items-center pb-1 w-full">
                          <p className="w-[13px] flex items-center rounded-full h-[13px] bg-white"></p>
                          <p className="w-full h-[2px] bg-white"></p>
                        </div>
                      </div>
                      <div className=" text-[14px] justify-start">
                        <ReviewCardBasic
                          review={review}
                          preview={preview}
                          color={BtIColor}
                          Iconcolor={Iconcolor}
                          textColor={Textcolor}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  <div className="mt-[40px] mr-[20px]">
                    <div
                      className={`${HighlightImageCheck ? "" : ""}`}
                      onClick={toggleGallery}
                    >
                      {HighlightImageCheck && (
                        <>
                          <div className="w-full p-3  items-center rounded-[34px]   flex justify-between bg-[#FFFFFF]">
                            <p className="flex items-center text-[#214E48] pt-3 text-center text-[19px] font-semibold">
                              Gallery
                            </p>
                            <svg
                              width="40"
                              height="15"
                              viewBox="0 0 40 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M38.8963 8.2071C39.2868 7.81658 39.2868 7.18341 38.8963 6.79289L32.5324 0.428929C32.1418 0.038405 31.5087 0.038405 31.1181 0.428929C30.7276 0.819454 30.7276 1.45262 31.1181 1.84314L36.775 7.5L31.1181 13.1569C30.7276 13.5474 30.7276 14.1805 31.1181 14.5711C31.5087 14.9616 32.1418 14.9616 32.5324 14.5711L38.8963 8.2071ZM8.74228e-08 8.5L38.1892 8.5L38.1892 6.5L-8.74228e-08 6.5L8.74228e-08 8.5Z"
                                fill="#3E0000"
                              />
                            </svg>
                          </div>
                        </>
                      )}
                    </div>

                    {showGallery && (
                      <div className="grid gap-2 grid-cols-2 items-center p-3">
                        {HighlightImageCheck && (
                          <HighlightImage preview={preview} />
                        )}
                      </div>
                    )}
                  </div>

                  <div className="mt-[40px] mr-[20px]">
                    <div
                      className={
                        fileName?.fileName1 ||
                          fileName?.fileName2 ||
                          fileName?.fileName3 ||
                          fileName?.fileName4
                          ? ""
                          : ""
                      }
                      onClick={toggleDownloads}
                    >
                      {fileName?.fileName1 ||
                        fileName?.fileName2 ||
                        fileName?.fileName3 ||
                        fileName?.fileName4 ? (
                        <>
                          <div className="w-full p-3 items-center rounded-[34px] my-5 flex justify-between bg-[#FFFFFF]">
                            <p className="flex items-center text-[#214E48] pt-3 text-center text-[19px] font-semibold">
                              Downloads
                            </p>
                            <svg
                              width="40"
                              height="15"
                              viewBox="0 0 40 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M38.8963 8.2071C39.2868 7.81658 39.2868 7.18341 38.8963 6.79289L32.5324 0.428929C32.1418 0.038405 31.5087 0.038405 31.1181 0.428929C30.7276 0.819454 30.7276 1.45262 31.1181 1.84314L36.775 7.5L31.1181 13.1569C30.7276 13.5474 30.7276 14.1805 31.1181 14.5711C31.5087 14.9616 32.1418 14.9616 32.5324 14.5711L38.8963 8.2071ZM8.74228e-08 8.5L38.1892 8.5L38.1892 6.5L-8.74228e-08 6.5L8.74228e-08 8.5Z"
                                fill="#3E0000"
                              />
                            </svg>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>

                    {showDownloads && (
                      <div className="grid gap-2 grid-cols-2 items-center p-3">
                        <DownloadBasic
                          files={files}
                          fileName={fileName}
                          preview={preview}
                          color={BtIColor}
                          Textcolor={Textcolor}
                          Iconcolor={Iconcolor}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {companyLogo[0]?.thumbUrl &&
                companyLogo[0]?.status !== "removed" ? (
                checkLogo ? (
                  <div
                    className="flex justify-center items-center mt-[20px] p-10"
                    style={{
                      backgroundColor: `${Highlightcolor ? Highlightcolor : "#650A0A"
                        }`,
                    }}
                  >
                    <div className="companyLogo ">
                      <img
                        src={
                          companyLogo[0]?.originFileObj?.type
                            ? URL.createObjectURL(companyLogo[0]?.originFileObj)
                            : companyLogo[0].thumbUrl
                        }
                        alt=""
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}


              {/*  --------------------------------- footer ---------------------------------  */}
              {footerText &&
                <Footer color={"#ffffff"} />
              }
            </div>
          </div>


        </div>
        {preview ? (
          <FloatButton.Group
            className="shadow-xl"
            trigger="click"
            color="black share_button"
            style={{
              left: "50%",
              color: BtIColor,
              position: "fixed",
              bottom: 20,
              marginLeft: "-20px",
            }}
            icon={<MenuOutlined style={{ color: BtIColor }} />}
          >
            {card?.exchangeContact?.show ? (
              <div onClick={(e) => e.stopPropagation()} className='mb-[12px]'>
                <FloatButton
                  icon={
                    <ExchangeContact
                      customButton={exchangeButton}
                      details={card?.exchangeContact}
                      cardId={card._id}
                    />
                  }
                />
              </div>
            ) : (
              ""
            )}
            <FloatButton
              icon={<ShareAltOutlined style={{ color: BtIColor }} />}
              onClick={handleShare}
            />
            <FloatButton
              icon={<QrcodeOutlined style={{ color: BtIColor }} />}
              onClick={() => setQrModal(true)}
            />
            <Link
              to={contactDetails?.locationUrl}
              target={`${preview ? "_blank" : ""}`}
            >
              <FloatButton icon={<FaLocationArrow color={BtIColor} />} />
            </Link>
          </FloatButton.Group>
        ) : (
          ""
        )}
        {qrModal ? <QRModal handleClose={handleClose} /> : null}
      </div>
    </>
  );
}

export default PeasantTheme;
